// extracted by mini-css-extract-plugin
export var eyeIcon = "image-module--eye-icon--88523";
export var imageHover = "image-module--image-hover--2c5b2";
export var imageWrap = "image-module--image-wrap--89153";